import { Router } from '@reach/router';
import React, { memo } from 'react';
import { RouteFC } from 'util/routeTypes';
import { CollectInfoForm } from './CollectInfoForm/CollectInfoForm';
import { VerifyEmailAddress } from './VerifyEmailAddress/VerifyEmailAddress';
import { VerifyPhoneNumber } from './VerifyPhoneNumber/VerifyPhoneNumber';

export const AuthenticationRoute: RouteFC = memo(() => {

  return (
    <Router>
      <CollectInfoForm path="info" default />
      <VerifyPhoneNumber path="phone" />
      <VerifyEmailAddress path="email" />
    </Router>
  );
});
